enum CreditScoreCategory {
  Poor = 'Poor', // 300-579
  Fair = 'Fair', // 580-669
  Good = 'Good', // 670-739
  VeryGood = 'Very Good', // 740-799
  Excellent = 'Excellent', // 800-850
}

export const CREDIT_SCORE_CATEGORIES_LIST = Object.values(CreditScoreCategory);

export default CreditScoreCategory;

export const MIN_CREDIT_SCORE = 300;
export const MAX_CREDIT_SCORE = 850;

/**
 * Threshold values for credit score categories.
 * Used to determine which category a score falls into.
 */
export const CREDIT_SCORE_THRESHOLDS = {
  POOR: 580,
  FAIR: 670,
  GOOD: 740,
  VERY_GOOD: 800,
} as const;

export const getCreditScoreCategory = (score: number): CreditScoreCategory => {
  if (score < CREDIT_SCORE_THRESHOLDS.POOR) return CreditScoreCategory.Poor;
  if (score < CREDIT_SCORE_THRESHOLDS.FAIR) return CreditScoreCategory.Fair;
  if (score < CREDIT_SCORE_THRESHOLDS.GOOD) return CreditScoreCategory.Good;
  if (score < CREDIT_SCORE_THRESHOLDS.VERY_GOOD) return CreditScoreCategory.VeryGood;
  return CreditScoreCategory.Excellent;
};

const CREDIT_SCORE_CATEGORIES_RANGES = {
  [CreditScoreCategory.Poor]: {
    min: MIN_CREDIT_SCORE,
    max: CREDIT_SCORE_THRESHOLDS.POOR - 1,
  },
  [CreditScoreCategory.Fair]: {
    min: CREDIT_SCORE_THRESHOLDS.POOR,
    max: CREDIT_SCORE_THRESHOLDS.FAIR,
  },
  [CreditScoreCategory.Good]: {
    min: CREDIT_SCORE_THRESHOLDS.FAIR,
    max: CREDIT_SCORE_THRESHOLDS.GOOD - 1,
  },
  [CreditScoreCategory.VeryGood]: {
    min: CREDIT_SCORE_THRESHOLDS.GOOD,
    max: CREDIT_SCORE_THRESHOLDS.VERY_GOOD - 1,
  },
  [CreditScoreCategory.Excellent]: {
    min: CREDIT_SCORE_THRESHOLDS.VERY_GOOD,
    max: MAX_CREDIT_SCORE,
  },
};
export const getCreditScoreCategoryProgressPercentage = (score: number): number => {
  const creditScoreCategory = getCreditScoreCategory(score);
  const range = CREDIT_SCORE_CATEGORIES_RANGES[creditScoreCategory];
  if (!range) return 0;
  const rangeSize = range.max - range.min;
  const scoreInRange = score - range.min;
  return (scoreInRange / rangeSize) * 100;
};
